import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerStateService {
  private requestsCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  /**
   * Show Spinner
   * Increment the request counter from interceptor and set loading to true
   */
  public show(): void {
    this.requestsCount++;
    if (this.requestsCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  /**
   * Hide Spinner
   * Decrement the request counter from interceptor and set loading to false
   */
  public hide(): void {
    if (this.requestsCount > 0) {
      this.requestsCount--;
    }
    if (this.requestsCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  /**
   * Forcefully remove spinner
   */
  public removeSpinner(): void {
    this.requestsCount = 0;
    this.hide();
  }
}
